import { Backend } from '@/_axios';

export default {
  // list(projectId, labelSetId, params) {
  //   return Backend.get(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/`, { params });
  // },
  // createData(projectId, labelSetId) {
  //   return Backend.get(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/create`);
  // },
  // editData(projectId, labelSetId, id) {
  //   return Backend.get(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/${id}/edit`);
  // },
  // create(projectId, labelSetId, data) {
  //   return Backend.post(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/`, data);
  // },
  // update(projectId, labelSetId, data) {
  //   return Backend.put(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/${data.id}`, data);
  // },
  // delete(projectId, labelSetId, id) {
  //   return Backend.delete(`/project/${projectId}/label_set/${labelSetId}/label_set_tags/${id}`);
  // },
};
